module.exports = __webpack_public_path__ + "img/supplier-icon.578a792c.png";